var _path, _circle, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.32031 13.0329V25.228C5.32031 25.5698 5.50262 25.8855 5.79855 26.0564C6.09449 26.2272 6.45909 26.2272 6.75503 26.0564C7.05096 25.8855 7.23327 25.5698 7.23327 25.228V13.5853L20.0725 20.9975V35.8229L18.6378 34.9941C18.1802 34.73 17.5952 34.8869 17.331 35.3445C17.0669 35.8021 17.2238 36.3871 17.6814 36.6512L19.5943 37.7579C20.0158 37.9995 20.4917 38.13 20.9774 38.1371C20.9946 38.1371 21.0109 38.1424 21.0285 38.1424C21.0462 38.1424 21.0625 38.1381 21.0797 38.1371C21.5657 38.13 22.042 37.9995 22.4637 37.7579L35.303 30.3452C36.1902 29.8311 36.7367 28.8837 36.7377 27.8583V13.0329C36.7366 12.0076 36.1901 11.0603 35.303 10.5461L22.4637 3.1334C21.5756 2.6222 20.4825 2.6222 19.5943 3.1334L6.75503 10.5461C5.86795 11.0603 5.32143 12.0076 5.32031 13.0329ZM13.6216 8.7924L26.4604 16.2051L21.029 19.3409L8.18927 11.9282L13.6216 8.7924ZM34.3465 28.6871L21.9855 35.8234V20.998L28.8439 17.0392L34.8219 13.5877V27.8583C34.8223 28.1993 34.6412 28.5147 34.3465 28.6862V28.6871ZM20.5508 4.79193C20.8467 4.62107 21.2113 4.62107 21.5073 4.79193L33.8688 11.9287L28.3738 15.1013L15.5345 7.68862L20.5508 4.79193Z",
    fill: "#8CAEB4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.8125,
    cy: 31.5,
    r: 5.25,
    fill: "#F3A414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6289 18.9337C31.1847 18.6783 30.6383 18.6783 30.1942 18.9337L25.7408 21.5038C25.2973 21.7609 25.024 22.2345 25.0234 22.7472V25.499C25.0231 26.0117 25.2964 26.4857 25.7404 26.7422C26.1844 26.9987 26.7315 26.9988 27.1755 26.7424L31.6284 24.1714C32.0719 23.9143 32.3452 23.4407 32.3458 22.928V20.1762C32.3451 19.664 32.072 19.1907 31.6289 18.9337ZM30.4333 22.6506L26.9369 24.6693V23.0222L30.4333 21.0045V22.6506Z",
    fill: "#8CAEB4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4671 37.6608C14.9007 37.6608 17.6842 34.8773 17.6842 31.4437C17.6842 28.0101 14.9007 25.2266 11.4671 25.2266C8.03349 25.2266 5.25 28.0101 5.25 31.4437C5.25395 34.8756 8.03513 37.6568 11.4671 37.6608ZM11.4671 27.1395C13.8442 27.1395 15.7713 29.0666 15.7713 31.4437C15.7713 33.8208 13.8442 35.7478 11.4671 35.7478C9.08999 35.7478 7.16296 33.8208 7.16296 31.4437C7.16559 29.0676 9.09108 27.1422 11.4671 27.1395Z",
    fill: "#F3A414"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2228 33.5524C12.5981 33.9148 13.1946 33.9097 13.5636 33.5407C13.9325 33.1718 13.9377 32.5752 13.5752 32.1999L12.4208 31.0454V29.0502C12.4208 28.522 11.9925 28.0938 11.4643 28.0938C10.936 28.0938 10.5078 28.522 10.5078 29.0502V31.4414C10.5079 31.6951 10.6087 31.9383 10.7881 32.1177L12.2228 33.5524Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingOrder);
export default __webpack_public_path__ + "static/media/Pending-order.3d274cc0123b13ab6858aff1e0383654.svg";
export { ForwardRef as ReactComponent };